import React, { Component } from "react";
import "./Header.scss";
import dayjs from "utils/dayjs";
import TmlLogo from "../../images/TataMotorsLogo@2x.png";
import {
  getUsername,
  getUser,
  extractRoleFromJWTToken,
} from "../../utils/Common";
import { clearUserSession } from "actions/userSessionActions";
import Agentstatus from "../Agentstatus/Agentstatus";
import { uepClient } from "uepClient";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TimeCounter from "components/TimeCounter/TimeCounter";
import { UserGroup, UserStatus } from "constants/UserConstants";
import { statusOptions, UserRoles } from "constants/UserConstants";
import WithAlert from "hoc/WithAlert";
import authClient from "authClient";
import { getGroup } from "utils/Common";

class Header extends Component {
  constructor(props) {
    super(props);
    this.username = getUsername();
    this.getStatusLabel = this.getStatusLabel.bind(this);
    this.statusLabel = this.getStatusLabel(this.props.agentStatus);
    this.getTimeDifference = this.getTimeDifference.bind(this);
    this.state = { initialTime: null };
  }

  componentDidMount = () => {
    this.setState({ initialTime: this.getTimeDifference() });
  };

  componentDidUpdate = (preProps) => {
    if (preProps.agentStatus !== this.props.agentStatus) {
      this.setState({ initialTime: this.getTimeDifference() });
    }
    //Handling Not_Ready Case separately AS Not_Ready is always set in the Initial State so above comparison won't work.
    if (
      this.props.agentStatus === "NOT_READY" &&
      preProps.agentStatusTime !== this.props.agentStatusTime
    ) {
      this.setState({ initialTime: this.getTimeDifference() });
    }
  };

  getDisplayName = () => {
    let displayName;
    const userFullName = getUser();
    if (!userFullName || userFullName === "") {
      displayName = getUsername();
    } else {
      displayName = userFullName;
    }
    return displayName;
  };

  getStatusLabel = (status) => {
    let optionToSelect = statusOptions[0];
    if (status !== UserStatus.LOGIN && status !== UserStatus.LOGOUT) {
      optionToSelect = statusOptions.find((option) => option.value === status);
    }
    return optionToSelect.label;
  };

  handleLogout = () => {
    if (this.canLogout()) {
      uepClient()
        .post(`/auth/logout`, { username: this.username })
        .then(() => {
          this.props.clearUserSession();
          authClient.logout();
          this.props.history.push("/");
        })
        .catch((error) => {
          console.error(
            "Some error occured while trying to log out.",
            error.message
          );
        });
    } else {
      this.props.showAlert({
        variant: "danger",
        content: (
          <span>
            <b>Error!</b> Please dispose the active conversations before logging
            out!
          </span>
        ),
      });
    }
  };

  canLogout = () => {
    if (extractRoleFromJWTToken() === UserRoles.AGENT) {
      const activeConversationCount = this.props.conversations.filter(
        (conv) => conv.status === "OPEN"
      ).length;
      return activeConversationCount === 0;
    }
    return true;
  };

  getTimeDifference = () => {
    const currentDateTime = dayjs().utc().format("YYYY-MM-DD HH:mm:ss");
    const statusTime = dayjs(this.props.agentStatusTime).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    const diff = dayjs(currentDateTime).diff(dayjs(statusTime));

    if (isNaN(diff)) {
      return 0;
    }

    return parseInt(diff);
  };

  getUserRole = () => {
    return extractRoleFromJWTToken();
  };

  render() {
    const userRole = extractRoleFromJWTToken();
    const group = getGroup();
    const roleClass = userRole === UserRoles.AGENT ? "agent" : "supervisor";
    return (
      <div className={`header ${roleClass} ${group}`} data-testid="header">
        <div className="logo-ctr">
          <img src={TmlLogo} className="tml-logo" alt="TML"></img>
        </div>
        <h2 className="title">Unified Engagement Platform</h2>
        {userRole === UserRoles.AGENT && group != UserGroup.OPPORTUNITY && (
          <div className="status">
            <div className="status-heading">Status</div>
            <Agentstatus username={this.username} />
          </div>
        )}
        <div className="username-ctr">
          <div className="username">{this.getDisplayName()}</div>
        </div>
        {userRole === UserRoles.AGENT && group != UserGroup.OPPORTUNITY && (
          <div className="break-time">
            <div>
              <span className="status-text">
                {this.getStatusLabel(this.props.agentStatus)} : &nbsp;
              </span>
              <span className="timer">
                <TimeCounter
                  key={this.state.initialTime + this.props.agentStatus}
                  initialTime={this.state.initialTime}
                />
              </span>{" "}
            </div>
          </div>
        )}
        <div className="logout" onClick={this.handleLogout}>
          <span className="logout-text">Logout</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  agentStatus: state.user.status,
  agentStatusTime: state.user.statusTime,
  conversations: state.conversation.conversations,
});

const mapDispatchToProps = {
  clearUserSession: clearUserSession,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WithAlert(Header)));
